export function readJsonScript(id, fallback = {}) {
  const node = document.getElementById(id);
  if (!node || !node.textContent) return fallback;

  try {
    return JSON.parse(node.textContent);
  } catch (_error) {
    return fallback;
  }
}
